import { NgModule } from '@angular/core';
import { RouterModule, Routes, UrlMatchResult, UrlSegment } from '@angular/router';
import { MailboxPageComponent } from './mailbox-page/mailbox-page.component';

/// Empareja `/mailbox`, `/mailbox/:accountId`, `/mailbox/:accountId/:folder` y
/// `/mailbox/:accountId/:folder/:uid` con **una sola** definición de ruta.
///
/// Es la razón de existir de este emparejador. Con cuatro rutas separadas, pasar de la carpeta al mensaje
/// (`/INBOX` -> `/INBOX/123456`) cambia de definición, y entonces Angular **destruye el componente y lo crea de
/// nuevo**: al abrir el primer mensaje se recargaban el árbol de carpetas y el listado, y la pantalla parpadeaba
/// como si se hubiera recargado. Angular solo reutiliza el componente cuando cambian los parámetros dentro de la
/// misma definición, y de ahí que haya que unificarlas.
export function mailboxUrlMatcher(segments: UrlSegment[]): UrlMatchResult | null {
  if (segments.length === 0 || segments[0].path !== 'mailbox') return null;

  //mailbox + cuenta + carpeta + mensaje. Más segmentos no son de esta pantalla.
  if (segments.length > 4) return null;

  const posParams: { [name: string]: UrlSegment } = {};
  if (segments[1]) posParams['accountId'] = segments[1];
  if (segments[2]) posParams['folder'] = segments[2];
  if (segments[3]) posParams['uid'] = segments[3];

  return { consumed: segments, posParams };
}

/// La cuenta, la carpeta y el mensaje van en la ruta (no en parámetros de consulta) para que un correo concreto se
/// pueda enlazar y para que el botón de atrás cierre el mensaje en lugar de salir de la pantalla.
///
/// La carpeta va codificada, porque los nombres de carpeta IMAP llevan dentro el separador de nivel ("/" o ".") y
/// sin codificar partirían la ruta. El componente la descodifica al leerla.
const routes: Routes = [
  { matcher: mailboxUrlMatcher, component: MailboxPageComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MailboxRoutingModule { }
